import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import GlossaryTitle from 'components/molecules/GlossaryTitle';
import SideBarContainer from 'containers/SideBarContainer';
import GlossaryTable from 'components/molecules/tables/GlossaryTable';
import PageTitle from 'hoc/PageTitle';
import PageTheme from 'hoc/PageTheme';
import PageView from 'hoc/PageView';
import ProtectedRoute from 'hoc/ProtectedRoute';
import { userShowGGBranding } from 'helpers/showGGBrandingTheme';
import { SideBarObjects } from 'components/pages/config/HomeSideBarObjects';

const GlossaryIndexPage = () => (
    <AdminTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<GlossaryTitle />}>

        <GlossaryTable />
    </AdminTemplate>
);

export default compose(
    ProtectedRoute(),
    PageTitle({ pageTitle: 'Dashboards Glossary' }),
    PageView({ page: 'Viewed Glossary Page' }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': userShowGGBranding } }),
)(GlossaryIndexPage);



// WEBPACK FOOTER //
// ./src/components/pages/home/GlossaryIndex.js